// extracted by mini-css-extract-plugin
export var border = "_1i-8";
export var brand = "_1i-t";
export var button = "_1i-l";
export var center = "_1i-a";
export var centered = "_1i-6";
export var closeButton = "_1i-c";
export var disabledWrapper = "_1i-m";
export var error = "_1i-p";
export var extraLarge = "_1i-4";
export var extraSmall = "_1i-1";
export var fill = "_1i-i";
export var footer = "_1i-h";
export var footerAction = "_1i-j";
export var footerButtons = "_1i-k";
export var header = "_1i-7";
export var headerWithClose = "_1i-d";
export var icon = "_1i-o";
export var info = "_1i-s";
export var inline = "_1i-9";
export var large = "_1i-3";
export var main = "_1i-e";
export var modal = "_1i-0";
export var nearFull = "_1i-5";
export var neutral = "_1i-u";
export var noPadding = "_1i-g";
export var none = "_1i-v";
export var scrollable = "_1i-f";
export var small = "_1i-2";
export var success = "_1i-r";
export var tight = "_1i-n";
export var titleIcon = "_1i-b";
export var warn = "_1i-q";